let getMsgCode,
  submitPhone,
  submitBirth,
  loginStatus,
  cardCenter,
  notice,
  cardCode,
  readGiftReceipt,
  confirmGiftReceipt,
  gainProcotol,
  confirmProtocol,
  readAgreement,
  personalBill,
  displayAction,
  actionDetail,
  getOpenId,
  getProofUrl,
  getDetailUrl,
  rebateDetailUrl,
  homeBanner,
  getAgreementContract,
  reviewDistributorlist,
  reviewSaleslist,
  reviewTaglist,
  reviewSalescreate,
  reviewDistributorcreate,
  vaildGrade,
  cartonqrcode

const moduleName = 'wechat-cust.'

export const setApiUrl = urlMap => {
  getMsgCode = urlMap[moduleName + 'getMsgCode']
  submitPhone = urlMap[moduleName + 'submitPhone']
  submitBirth = urlMap[moduleName + 'submitBirth']
  loginStatus = urlMap[moduleName + 'loginStatus']
  cardCenter = urlMap[moduleName + 'cardCenter']
  notice = urlMap[moduleName + 'notice']
  cardCode = urlMap[moduleName + 'cardCode']
  readGiftReceipt = urlMap[moduleName + 'readGiftReceipt']
  confirmGiftReceipt = urlMap[moduleName + 'confirmGiftReceipt']
  gainProcotol = urlMap[moduleName + 'gainProcotol']
  confirmProtocol = urlMap[moduleName + 'confirmProtocol']
  readAgreement = urlMap[moduleName + 'readAgreement']
  personalBill = urlMap[moduleName + 'personalBill']
  displayAction = urlMap[moduleName + 'displayAction']
  actionDetail = urlMap[moduleName + 'actionDetail']
  getOpenId = urlMap[moduleName + 'getOpenId']
  getProofUrl = urlMap[moduleName + 'getProofUrl']
  getDetailUrl = urlMap[moduleName + 'getDetailUrl']
  rebateDetailUrl = urlMap[moduleName + 'rebateDetailUrl']
  homeBanner = urlMap[moduleName + 'homeBanner']
  getAgreementContract = urlMap[moduleName + 'getAgreementContract']
  reviewDistributorlist = urlMap[moduleName + 'reviewDistributorlist']
  reviewSaleslist = urlMap[moduleName + 'reviewSaleslist']
  reviewTaglist = urlMap[moduleName + 'reviewTaglist']
  reviewSalescreate = urlMap[moduleName + 'reviewSalescreate']
  reviewDistributorcreate = urlMap[moduleName + 'reviewDistributorcreate']
  vaildGrade = urlMap[moduleName + 'vaildGrade']
  cartonqrcode = urlMap[moduleName + 'cartonqrcode']
}

// export const setUrl = module => {
//   const tp = module.tp
//   const basic = module.basic
//   const contract = module.contract
//   getMsgCode = basic + 'wcv1/user/smscode'
//   submitPhone = basic + 'wcv1/user/mobilemodify'
//   submitBirth = basic + 'wcv1/user/birthdaymodify'
//   loginStatus = basic + 'wcv1/user/bindstatus'
//   cardCenter = tp + 'wcv1/card/search'
//   notice = tp + 'wcv1/card/notice'
//   cardCode = basic + 'wcv1/card/qrcode'
//   readGiftReceipt = tp + 'wcv1/rebatesku/list'
//   confirmGiftReceipt = tp + 'wcv1/rebatesku/comfirm'
//   gainProcotol = contract + 'wcv1/agreement/djtldetail'
//   confirmProtocol = tp + 'wcv1/agreement/confirm'
//   readAgreement = tp + 'wcv1/agreement/unconfirmlist'
//   personalBill = tp + 'wcv1/rebate/list'
//   displayAction = tp + 'wcv1/agreement/list'
//   actionDetail = basic + 'wcv1/user/detail'
//   getOpenId = tp + 'wcv1/user/getopenid'
//   getProofUrl = tp + 'wcv1/agreement/rebatecert'
//   getDetailUrl = tp + 'wcv1/agreement/agreementdetail'
//   rebateDetailUrl = tp + 'wcv1/agreement/rebatedetail'
//   homeBanner = basic + 'wcv1/banner/list'
//   getAgreementContract = tp + 'wcv1/agreement/getAgreementContract'
//   reviewDistributorlist = basic + 'wcv1/review/distributorlist'
//   reviewSaleslist = basic + 'wcv1/review/saleslist'
//   reviewTaglist = basic + 'wcv1/review/taglist'
//   reviewSalescreate = basic + 'wcv1/review/salescreate'
//   reviewDistributorcreate = basic + 'wcv1/review/distributorcreate'
//   vaildGrade = basic + 'wcv1/review/checkvalide'
//   cartonqrcode = basic + 'wcv1/user/cartonqrcode'
// }
// 获取短信验证码
// export const getMsgCode = 'cpm-basic-management/wcv1/user/smscode'
// export const getMsgCode = basic + 'wcv1/user/smscode'

// 微信绑定手机提交
// export const submitPhone = 'cpm-basic-management/wcv1/user/mobilemodify'
// export const submitPhone = basic + 'wcv1/user/mobilemodify'

// 修改商户生日提交
// export const submitBirth = 'cpm-basic-management/wcv1/user/birthdaymodify'
// export const submitBirth = basic + 'wcv1/user/birthdaymodify'

// 商户绑定状态
// export const loginStatus = 'cpm-basic-management/wcv1/user/bindstatus'
// export const loginStatus = basic + 'wcv1/user/bindstatus'

// 卡券中心
// export const cardCenter = 'cpm-tp-management/wcv1/card/search'
// export const cardCenter = tp + 'wcv1/card/search'

// 卡券详情
// export const notice = 'cpm-tp-management/wcv1/card/notice'
// export const notice = tp + 'wcv1/card/notice'

// export const cardCode = 'cpm-basic-management/wcv1/card/qrcode'
// export const cardCode = basic + 'wcv1/card/qrcode'

// 赠品签收读取
// export const readGiftReceipt = 'cpm-tp-management/wcv1/rebatesku/list'
// export const readGiftReceipt = tp + 'wcv1/rebatesku/list'

// 赠品签收提交
// export const confirmGiftReceipt = 'cpm-tp-management/wcv1/rebatesku/comfirm'
// export const confirmGiftReceipt = tp + 'wcv1/rebatesku/comfirm'

// 协议获取
// export const gainProcotol = 'cpm-digital-contract/wcv1/agreement/djtldetail'
// export const gainProcotol = contract + 'wcv1/agreement/djtldetail'

// 协议确认
// export const confirmProtocol = 'cpm-tp-management/wcv1/agreement/confirm'
// export const confirmProtocol = tp + 'wcv1/agreement/confirm'

// 待签协议读取gainProcotol
// export const readAgreement = 'cpm-tp-management/wcv1/agreement/unconfirmlist'
// export const readAgreement = tp + 'wcv1/agreement/unconfirmlist'

// 个人账单
// export const personalBill = 'cpm-tp-management/wcv1/rebate/list'
// export const personalBill = tp + 'wcv1/rebate/list'

// 陈列活动
// export const displayAction = 'cpm-tp-management/wcv1/agreement/list'
// export const displayAction = tp + 'wcv1/agreement/list'

// 活动详情
// export const actionDetail = 'cpm-basic-management/wcv1/user/detail'
// export const actionDetail = basic + 'wcv1/user/detail'

// 获取openid
// export const getOpenId = 'cpm-tp-management/wcv1/user/getopenid'
// export const getOpenId = tp + 'wcv1/user/getopenid'
// 协议返还详情-返还凭证读取
// export const getProofUrl = 'cpm-tp-management/wcv1/agreement/rebatecert'
// export const getProofUrl = tp + 'wcv1/agreement/rebatecert'

// 协议返还详情-签约详情读取
// export const getDetailUrl = 'cpm-tp-management/wcv1/agreement/agreementdetail'
// export const getDetailUrl = tp + 'wcv1/agreement/agreementdetail'

// 协议返还详情读取
// export const rebateDetailUrl = 'cpm-tp-management/wcv1/agreement/rebatedetail'
// export const rebateDetailUrl = tp + 'wcv1/agreement/rebatedetail'

// 首页banner
// export const homeBanner = 'cpm-basic-management/wcv1/banner/list'
// export const homeBanner = basic + 'wcv1/banner/list'

// export const getAgreementContract = 'cpm-tp-management/wcv1/agreement/getAgreementContract'
// export const getAgreementContract = tp + 'wcv1/agreement/getAgreementContract'

// 配送商评论读取
// export const reviewDistributorlist = 'cpm-basic-management/wcv1/review/distributorlist'
// export const reviewDistributorlist = basic + 'wcv1/review/distributorlist'
// 业代评论读取
// export const reviewSaleslist = 'cpm-basic-management/wcv1/review/saleslist'
// export const reviewSaleslist = basic + 'wcv1/review/saleslist'
// 评论标签读取
// export const reviewTaglist = 'cpm-basic-management/wcv1/review/taglist'
// export const reviewTaglist = basic + 'wcv1/review/taglist'
// 业代评论提交
// export const reviewSalescreate = 'cpm-basic-management/wcv1/review/salescreate'
// export const reviewSalescreate = basic + 'wcv1/review/salescreate'
// 配送商评论提交
// export const reviewDistributorcreate = 'cpm-basic-management/wcv1/review/distributorcreate'
// export const reviewDistributorcreate = basic + 'wcv1/review/distributorcreate'
// 检查评价是否可用
// export const vaildGrade = 'cpm-basic-management/wcv1/review/checkvalide'
// export const vaildGrade = basic + 'wcv1/review/checkvalide'

// 商户纸箱二维码
// export const cartonqrcode = 'cpm-basic-management/wcv1/user/cartonqrcode'
// export const cartonqrcode = basic + 'wcv1/user/cartonqrcode'

export {
  getMsgCode,
  submitPhone,
  submitBirth,
  loginStatus,
  cardCenter,
  notice,
  cardCode,
  readGiftReceipt,
  confirmGiftReceipt,
  gainProcotol,
  confirmProtocol,
  readAgreement,
  personalBill,
  displayAction,
  actionDetail,
  getOpenId,
  getProofUrl,
  getDetailUrl,
  rebateDetailUrl,
  homeBanner,
  getAgreementContract,
  reviewDistributorlist,
  reviewSaleslist,
  reviewTaglist,
  reviewSalescreate,
  reviewDistributorcreate,
  vaildGrade,
  cartonqrcode
}



// WEBPACK FOOTER //
// ./src/api/api.js